import { dataGallery } from 'dls-icons-data'
import { createIcon } from '../common'

const IconGallery = /*#__PURE__*/createIcon(dataGallery)
export default IconGallery
